<template>
  <b-card title="ตั้งค่าหวย">
    <b-overlay :show="isShowOverlay">
      <div v-if="lottoDemo" class="text-right">
        <template v-if="dayjs().isBefore(lottoDemo.endAt)">
          <b-button v-if="lottoDemo.status === 'OPEN'" size="sm" variant="danger" @click="toggleBetStatus">ปิดรับแทง</b-button>
          <b-button v-else-if="lottoDemo.status === 'CLOSED'" size="sm" variant="info" @click="toggleBetStatus">เปิดรับแทง</b-button>
        </template>
        <template v-else>
          <b-button v-b-modal.result-modal size="sm" variant="success">ออกผล</b-button>
          <ValidationObserver ref="notificationForm" v-slot="{ handleSubmit }">
            <b-modal
                id="result-modal"
                :ok-disabled="!isAlreadyPreview || isFetchingResult"
                cancel-title="ยกเลิก"
                ok-title="ยืนยัน"
                title="ออกผลหวย"
                @hidden="onModalHidden"
                @ok.prevent="handleSubmit(onSubmitResult)"
            >
              <form @submit.prevent="handleSubmit(onSubmitResult)">
                <ValidationProvider
                    v-slot="{ errors }"
                    name="betNumber"
                    rules="required|numeric|length:2"
                >
                  <b-form-group label="ใส่เลขสองตัว" label-cols-md="3">
                    <b-form-input
                        id="betNumber"
                        v-model="betNumber"
                        :disabled="isFetchingResult"
                        :state="errors[0] ? false : null"
                        maxlength="2"
                    />
                  </b-form-group>
                </ValidationProvider>
                <div class="text-right">
                  <b-button :disabled="isFetchingResult" size="sm" type="submit" variant="success">คำนวณผลลัพธ์</b-button>
                </div>

                <template v-if="!!previewWinner">
                  <hr />
                  <b-row>
                    <b-col md="3">
                      <b>จำนวนยูสที่ถูก</b>
                    </b-col>
                    <b-col md="8">{{ previewWinner.count }} ยูส</b-col>
                    <b-col md="3">
                      <b>จ่ายทั้งหมด</b>
                    </b-col>
                    <b-col md="8">{{ +previewWinner.count * +lottoDemo.winPrize }} เครดิต</b-col>
                  </b-row>
                </template>
              </form>
            </b-modal>
          </ValidationObserver>
        </template>
      </div>
      <ValidationObserver
          ref="depositForm"
          v-slot="{ handleSubmit }"
      >
        <form @submit.prevent="handleSubmit(onSubmit)">
          <b-row class="mb-3">
            <b-col cols="2">สถานะ</b-col>
            <b-col cols="10">
              <b-badge v-if="!lottoDemo">ไม่มีรอบ</b-badge>
              <b-badge v-else-if="dayjs().isAfter(lottoDemo.endAt)" variant="warning">รอออกผล</b-badge>
              <b-badge v-else-if="lottoDemo.status === 'OPEN'" variant="primary">เปิดรับแทง</b-badge>
              <b-badge v-else-if="lottoDemo.status === 'CLOSED'" variant="danger">ปิดรับแทง</b-badge>
            </b-col>
          </b-row>

          <ValidationProvider
              v-slot="{ errors }"
              name="งวดวันที่"
              rules="required"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                label="งวดวันที่"
                label-cols-lg="2"
                label-cols-sm="12"
                label-for="roundDate"
            >
              <DateTimePicker id="roundDate" v-model="form.roundDate" :class="{ 'is-invalid': errors[0] }" format="YYYY-MM-DD" formatted="YYYY-MM-DD" only-date />
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
              v-slot="{ errors }"
              name="เปิดรับแทง"
              rules="required"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                label="เปิดรับแทง"
                label-cols-lg="2"
                label-cols-sm="12"
                label-for="startAt"
            >
              <DateTimePicker id="startAt" v-model="form.startAt" :class="{ 'is-invalid': errors[0] }" />
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
              v-slot="{ errors }"
              name="ปิดรับแทง"
              rules="required"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                label="ปิดรับแทง"
                label-cols-lg="2"
                label-cols-sm="12"
                label-for="endAt"
            >
              <DateTimePicker id="endAt" v-model="form.endAt" :class="{ 'is-invalid': errors[0] }" />
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
              v-slot="{ errors }"
              name="ราคาจ่าย"
              rules="required|numeric|min_value:1"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                label="ราคาจ่าย"
                label-cols-lg="2"
                label-cols-sm="12"
                label-for="winPrize"
            >
              <b-form-input
                  id="winPrize"
                  v-model.trim="form.winPrize"
                  :state="errors[0] ? false : null"
                  inputmode="numeric"
              ></b-form-input>
            </b-form-group>
          </ValidationProvider>

          <div class="text-right">
            <b-button type="submit" variant="primary">
              {{ $t('buttons.confirm') }}
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </b-overlay>
  </b-card>
</template>

<script>

import dayjs from 'dayjs';
import {mapActions, mapState} from 'vuex';

export default {
  name: 'LottoDemoForm',
  data() {
    return {
      isLoading: false,
      resultStep: 0,
      form: {
        startAt: null,
        endAt: null,
        roundDate: null,
        winPrize: ''
      },
      betNumber: '',
      isFetchingResult: false
    }
  },
  computed: {
    ...mapState({
      previewWinner: (state) => state['lotto-demo'].previewWinner,
      lottoDemo: (state) => state['lotto-demo'].currentRound,
      isShowOverlay(state) {
        return state['lotto-demo'].isFetchingCurrentRound || this.isLoading
      },
    }),
    dayjs() {
      return dayjs
    },
    isAlreadyPreview() {
      return this.previewWinner && this.previewWinner.betNumber === this.betNumber
    }
  },
  watch: {
    lottoDemo() {
      this.setData()
    }
  },
  methods: {
    ...mapActions(['resetPreviewWinner', 'submitLottoDemoResult', 'fetchPreviewWinner', 'fetchCurrentLottoDemo', 'createNewLottoDemoRound', 'updateLottoDemoRound', 'toggleLottoDemoBetStatus']),
    setData() {
      if (this.lottoDemo) {
        this.form.startAt = dayjs(this.lottoDemo.startAt).format('YYYY-MM-DD HH:mm:ss')
        this.form.endAt = dayjs(this.lottoDemo.endAt).format('YYYY-MM-DD HH:mm:ss')
        this.form.roundDate = dayjs(this.lottoDemo.roundDate).format('YYYY-MM-DD')
        this.form.winPrize = +this.lottoDemo.winPrize
      } else {
        this.reset()
      }
    },
    async getCurrentRound() {
      this.isLoading = true
      await this.fetchCurrentLottoDemo()
      this.setData()
      this.isLoading = false
    },
    reset() {
      this.form.startAt = null
      this.form.endAt = null
      this.form.roundDate = null
      this.form.winPrize = ''
    },
    async toggleBetStatus() {
      if (!this.lottoDemo) return
      this.isLoading = true
      await this.toggleLottoDemoBetStatus()
      await this.getCurrentRound()
      this.isLoading = false
    },
    async onSubmit() {
      this.isLoading = true
      if (this.lottoDemo) {
        await this.updateLottoDemoRound(this.getData())
      } else {
        await this.createNewLottoDemoRound(this.getData())
      }
      await this.getCurrentRound()
      this.isLoading = false
    },
    getData() {
      return {
        startAt: new Date(this.form.startAt),
        endAt: new Date(this.form.endAt),
        roundDate: this.form.roundDate,
        winPrize: +this.form.winPrize
      }
    },
    onModalHidden() {
      this.resetPreviewWinner()
    },
    async onSubmitResult() {
      if (this.isFetchingResult) return
      if (this.betNumber.length !== 2 || isNaN(this.betNumber)) {
        this.$bvToast.toast('ผลรางวัลไม่ถูกต้อง')
        return
      }
      this.isFetchingResult = true
      if (!this.isAlreadyPreview) {
        await this.fetchPreviewWinner(this.betNumber)
      } else {
        await this.submitLottoDemoResult(this.betNumber)
        await this.getCurrentRound()
        this.$bvModal.hide('result-modal')
      }
      this.isFetchingResult = false
    },
  },
}
</script>